var _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 1080,
    viewBox: "0 0 180 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#clip0_1352_10685)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(0 1 -1 0 180 0)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 180C78.3502 180 0 101.65 0 5C0 -91.6498 78.3502 -170 175 -170C271.65 -170 350 -91.6498 350 5C350 101.65 271.65 180 175 180ZM175 -84.6641C125.48 -84.6641 85.3359 -44.5201 85.3359 5C85.3359 54.5201 125.48 94.6641 175 94.6641C224.52 94.6641 264.664 54.5201 264.664 5C264.664 -44.5201 224.52 -84.6641 175 -84.6641Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(0 -1 1 0 0 360)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 310,
    width: 80,
    height: 80,
    transform: "rotate(-90 50 310)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1352_10685)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M153.919 386.36C189.066 421.508 189.066 478.492 153.919 513.64C118.772 548.787 61.7868 548.787 26.6396 513.64C-8.50758 478.492 -8.50758 421.508 26.6396 386.36C61.7868 351.213 118.772 351.213 153.919 386.36ZM57.6724 482.607C75.6807 500.615 104.878 500.615 122.886 482.607C140.894 464.599 140.894 435.401 122.886 417.393C104.878 399.385 75.6807 399.385 57.6724 417.393C39.6642 435.401 39.6642 464.599 57.6724 482.607Z",
    fill: "#0B68FE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#clip2_1352_10685)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(0 -1 1 0 0 720)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 540C101.65 540 180 618.35 180 715C180 811.65 101.65 890 5 890C-91.6498 890 -170 811.65 -170 715C-170 618.35 -91.6498 540 5 540ZM5 804.664C54.5201 804.664 94.6641 764.52 94.6641 715C94.6641 665.48 54.5201 625.336 5 625.336C-44.5201 625.336 -84.6641 665.48 -84.6641 715C-84.6641 764.52 -44.5201 804.664 5 804.664Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(0 -1 1 0 0 900)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 850,
    width: 80,
    height: 80,
    transform: "rotate(-90 50 850)",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#clip3_1352_10685)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    transform: "matrix(-1 0 0 -1 180 1080)",
    fill: "#0B68FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.919 926.36C189.066 961.508 189.066 1018.49 153.919 1053.64C118.772 1088.79 61.7868 1088.79 26.6396 1053.64C-8.50758 1018.49 -8.50758 961.508 26.6396 926.36C61.7868 891.213 118.772 891.213 153.919 926.36ZM57.6724 1022.61C75.6807 1040.62 104.878 1040.62 122.886 1022.61C140.894 1004.6 140.894 975.401 122.886 957.393C104.878 939.385 75.6807 939.385 57.6724 957.393C39.6642 975.401 39.6642 1004.6 57.6724 1022.61Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_10685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(0 1 -1 0 180 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1352_10685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 -1 180 540)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1352_10685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 720)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1352_10685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white",
    transform: "matrix(-1 0 0 -1 180 1080)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentBackground);
export default __webpack_public_path__ + "static/media/student-background.b529d2f7650792ebdab73bcacd1d57f5.svg";
export { ForwardRef as ReactComponent };